var header = document.getElementById('header');
var hamberger = document.querySelector('.hamberger');
var hamBtn = document.querySelector('.ham-btn');
var gnb = document.getElementById('gnb');
// Event
(function () {
	var unlistenableWindowEvents = {
		click: 1,
		dblclick: 1,
		keyup: 1,
		keypress: 1,
		keydown: 1,
		mousedown: 1,
		mouseup: 1,
		mousemove: 1,
		mouseover: 1,
		mouseenter: 1,
		mouseleave: 1,
		mouseout: 1,
		storage: 1,
		storagecommit: 1,
		textinput: 1
	};

	function indexOf(array, element) {
		var
		index = -1,
		length = array.length;

		while (++index < length) {
			if (index in array && array[index] === element) {
				return index;
			}
		}

		return -1;
	}

	var existingProto = (window.Event && window.Event.prototype) || null;
	window.Event = Window.prototype.Event = function Event(type, eventInitDict) {
		if (!type) {
			throw new Error('Not enough arguments');
		}

		// Shortcut if browser supports createEvent
		if ('createEvent' in document) {
			var event = document.createEvent('Event');
			var bubbles = eventInitDict && eventInitDict.bubbles !== undefined ? eventInitDict.bubbles : false;
			var cancelable = eventInitDict && eventInitDict.cancelable !== undefined ? eventInitDict.cancelable : false;

			event.initEvent(type, bubbles, cancelable);

			return event;
		}

		var event = document.createEventObject();

		event.type = type;
		event.bubbles = eventInitDict && eventInitDict.bubbles !== undefined ? eventInitDict.bubbles : false;
		event.cancelable = eventInitDict && eventInitDict.cancelable !== undefined ? eventInitDict.cancelable : false;

		return event;
	};
	if (existingProto) {
		Object.defineProperty(window.Event, 'prototype', {
			configurable: false,
			enumerable: false,
			writable: true,
			value: existingProto
		});
	}

	if (!('createEvent' in document)) {
		window.addEventListener = Window.prototype.addEventListener = Document.prototype.addEventListener = Element.prototype.addEventListener = function addEventListener() {
			var
			element = this,
			type = arguments[0],
			listener = arguments[1];

			if (element === window && type in unlistenableWindowEvents) {
				throw new Error('In IE8 the event: ' + type + ' is not available on the window object. Please see https://github.com/Financial-Times/polyfill-service/issues/317 for more information.');
			}

			if (!element._events) {
				element._events = {};
			}

			if (!element._events[type]) {
				element._events[type] = function (event) {
					var
					list = element._events[event.type].list,
					events = list.slice(),
					index = -1,
					length = events.length,
					eventElement;

					event.preventDefault = function preventDefault() {
						if (event.cancelable !== false) {
							event.returnValue = false;
						}
					};

					event.stopPropagation = function stopPropagation() {
						event.cancelBubble = true;
					};

					event.stopImmediatePropagation = function stopImmediatePropagation() {
						event.cancelBubble = true;
						event.cancelImmediate = true;
					};

					event.currentTarget = element;
					event.relatedTarget = event.fromElement || null;
					event.target = event.target || event.srcElement || element;
					event.timeStamp = new Date().getTime();

					if (event.clientX) {
						event.pageX = event.clientX + document.documentElement.scrollLeft;
						event.pageY = event.clientY + document.documentElement.scrollTop;
					}

					while (++index < length && !event.cancelImmediate) {
						if (index in events) {
							eventElement = events[index];

							if (indexOf(list, eventElement) !== -1 && typeof eventElement === 'function') {
								eventElement.call(element, event);
							}
						}
					}
				};

				element._events[type].list = [];

				if (element.attachEvent) {
					element.attachEvent('on' + type, element._events[type]);
				}
			}

			element._events[type].list.push(listener);
		};

		window.removeEventListener = Window.prototype.removeEventListener = Document.prototype.removeEventListener = Element.prototype.removeEventListener = function removeEventListener() {
			var
			element = this,
			type = arguments[0],
			listener = arguments[1],
			index;

			if (element._events && element._events[type] && element._events[type].list) {
				index = indexOf(element._events[type].list, listener);

				if (index !== -1) {
					element._events[type].list.splice(index, 1);

					if (!element._events[type].list.length) {
						if (element.detachEvent) {
							element.detachEvent('on' + type, element._events[type]);
						}
						delete element._events[type];
					}
				}
			}
		};

		window.dispatchEvent = Window.prototype.dispatchEvent = Document.prototype.dispatchEvent = Element.prototype.dispatchEvent = function dispatchEvent(event) {
			if (!arguments.length) {
				throw new Error('Not enough arguments');
			}

			if (!event || typeof event.type !== 'string') {
				throw new Error('DOM Events Exception 0');
			}

			var element = this, type = event.type;

			try {
				if (!event.bubbles) {
					event.cancelBubble = true;

					var cancelBubbleEvent = function (event) {
						event.cancelBubble = true;

						(element || window).detachEvent('on' + type, cancelBubbleEvent);
					};

					this.attachEvent('on' + type, cancelBubbleEvent);
				}

				this.fireEvent('on' + type, event);
			} catch (error) {
				event.target = element;

				do {
					event.currentTarget = element;

					if ('_events' in element && typeof element._events[type] === 'function') {
						element._events[type].call(element, event);
					}

					if (typeof element['on' + type] === 'function') {
						element['on' + type].call(element, event);
					}

					element = element.nodeType === 9 ? element.parentWindow : element.parentNode;
				} while (element && !event.cancelBubble);
			}

			return true;
		};

		// Add the DOMContentLoaded Event
		document.attachEvent('onreadystatechange', function() {
			if (document.readyState === 'complete') {
				document.dispatchEvent(new Event('DOMContentLoaded', {
					bubbles: true
				}));
			}
		});
	}
}());
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}
(function () {

  if ( typeof window.CustomEvent === "function" ) return false;

  function CustomEvent ( event, params ) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent( 'CustomEvent' );
    evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
    return evt;
   }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
})();

function index(el) {
	if (!el) return -1;
	var i = 0;
	do {
		i++;
	} while (el = el.previousElementSibling);
	return i;
}
function addClass(elem,className){
  let max = elem.length;
  for(let i=0;i<max; i++){
    elem[i].classList.add(className);
  }
}
function removeClass(elem,className){
  let max = elem.length;
  for(let i=0;i<max; i++){
    elem[i].classList.remove(className);
  }
}
let clickEvent = (function () {
	if ('ontouchstart' in document.documentElement === true) {
		return 'touchstart';
	} else {
		return 'click';
	}
})();
const mainVideoElem = document.getElementById('topVisual');
const menuItem = document.querySelectorAll('.depth1 > li');
const menuDepth2 = document.querySelectorAll('.depth2');
const menuBgItem = document.querySelectorAll('.gnb-menu-bg-item');
const gnbCursor = document.querySelector('.gnb-cursor');
function hide(elem){
  gsap.set(elem, {autoAlpha: 0});
}

menuDepth2.forEach(el=>hide(el));
menuItem.forEach(el=>{
	el.addEventListener("mouseenter",function(event){
		const depth2 = event.target.querySelector('.depth2');
		gsap.to(depth2,{autoAlpha:1})
	});
	el.addEventListener("mouseleave",function(event){
		const depth2 = event.target.querySelector('.depth2');
		gsap.to(depth2,{autoAlpha:0})
	});
})

menuBgItem.forEach((el,i)=>gsap.set(el,{autoAlpha:0}));
const menuEvent = function(){
	document.body.classList.toggle('open');
	header.classList.toggle('open');
	this.classList.toggle('open');
	gnb.classList.toggle('open');
	gnb.nextElementSibling.classList.toggle('open');
}
//클릭 이벤트
hamberger.addEventListener(clickEvent,menuEvent);

// const gnbDepth2 = document.querySelectorAll('.gnb-depth2');
// if(gnbDepth2){
// 	gnbDepth2.forEach(list=>{
// 		list.addEventListener(clickEvent,()=>{
// 			document.body.classList.remove('open');
// 			header.classList.remove('open');
// 			hamberger.classList.remove('open');
// 			gnb.classList.remove('open');
// 			gnb.nextElementSibling.classList.remove('open');
// 		});
// 	});
// }


const doctors = document.querySelector('.doctor-sect');
const plusBtn = document.querySelectorAll('.plus-btn button');

if(doctors){

	plusBtn.forEach(elem=>{
		elem.addEventListener(clickEvent,function(event){
			let tg = event.target.parentNode;
			tg.classList.toggle('expand');
			if(tg.classList.contains('dr-kim')){
				doctors.classList.toggle('dr-kim-expand');
			} else if(tg.classList.contains('dr-so')){
				doctors.classList.toggle('dr-so-expand');
			}
			//console.log(bg);
		});
	});
	
	doctors.addEventListener('mouseleave',function(){
		plusBtn.forEach(elem=>elem.classList.remove('expand'))
	});
}

(function() {
	var throttle = function(type, name, obj) {
			obj = obj || window;
			var running = false;
			var func = function() {
					if (running) { return; }
					running = true;
					 requestAnimationFrame(function() {
							obj.dispatchEvent(new CustomEvent(name));
							running = false;
					});
			};
			obj.addEventListener(type, func);
	};

	/* init - you can init any event */
	throttle("resize", "optimizedResize");
})();

let mainVideoSrc = "https://player.vimeo.com/video/502878804?loop=1&background=1&app_id=122963";

// handle event
window.addEventListener("optimizedResize", function() {
	const width = window.innerWidth;
	if(width >= 480){
		mainVideoSrc = "https://player.vimeo.com/video/502878804?loop=1&background=1&app_id=122963";
	} else if(width < 480){
		mainVideoSrc = "https://player.vimeo.com/video/513657934?loop=1&background=1&app_id=122963";
	}
});

window.dispatchEvent(new Event('optimizedResize'));


function changeIframeUrl(elem, url){elem.src = url;}


var mainVisual = new Swiper('.main-visual', {
	speed: 600,
	autoplay: {
		delay: 4000,
	},
	loop:true,
	// navigation: {
	// 	nextEl: '.service-content-wrap .ctrls.next',
	// 	prevEl: '.service-content-wrap .ctrls.prev',
	// },
	pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
  },
	on: {
    init: function () {
      header.classList.remove('white-header');
			hamberger.classList.remove('white-header');
    },
  },
});

function playerCtrl(index){
	switch(index){
		case 0:
			//1번째는 기본색
			header.classList.remove('white-header');
			hamberger.classList.remove('white-header');
			break;
		default:
			//나머지는 흰색
			header.classList.add('white-header');
			hamberger.classList.add('white-header');
	}
}

mainVisual.on('slidePrevTransitionStart',function(){
	var index = mainVisual.realIndex;
	//console.log(`slide number ${index}`);
	if(index == 2){
		const mainVideoPlayer = document.querySelectorAll('#mainVideo.video-background iframe');
		changeIframeUrl(mainVideoPlayer[0], mainVideoSrc);
		changeIframeUrl(mainVideoPlayer[1], '');
	}
	playerCtrl(index);
});

mainVisual.on('slideNextTransitionStart',function(){
	var index = mainVisual.realIndex;
	//console.log(`slide number ${index}`);
	if(index == 2){
		const mainVideoPlayer = document.querySelectorAll('#mainVideo.video-background iframe');
		changeIframeUrl(mainVideoPlayer[1], mainVideoSrc);
		changeIframeUrl(mainVideoPlayer[0], '');
	}
	playerCtrl(index);
});

const sub1 = document.querySelector("#topVisual.sub1-top");
if(sub1){
	header.classList.remove('white-header');
	hamberger.classList.remove('white-header');
}

var subjectSlide = new Swiper('.subject-slide', {
	speed: 600,
	autoplay: {
		delay: 4000,
	},
	slidesPerView:1.8,
	spaceBetween:60,
	//loop:true,
	navigation: {
		nextEl: '.service-content-wrap .ctrls.next',
		prevEl: '.service-content-wrap .ctrls.prev',
	},
	freeMode: true,
	scrollbar: {
		el: '.swiper-scrollbar',
		draggable: true,
		dragSize: 160
	},
	// Responsive breakpoints
  breakpoints: {
    // when window width is >= 320px
    590: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    // when window width is >= 480px
    768: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    // when window width is >= 640px
    1280: {
      slidesPerView: 1.5,
      spaceBetween: 40,
			scrollbar: {
				dragSize: 120
			},
    }
  }
});

var interiorThumb = new Swiper('.review-img', {
	speed:700,
	autoplay: {
		delay: 3000,
	},
	effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
	allowTouchMove:false,
	loop: true,
	loopedSlides: 4,
	watchSlidesVisibility: true,
	watchSlidesProgress: true,
	slideDuplicateActiveClass: 'swiper-slide-active'
});
var interiorView = new Swiper('.review-txt', {
	speed:700,
	navigation: {
			nextEl: '.wide-ctrls.next',
			prevEl: '.wide-ctrls.prev',
	},
	pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
  },
	autoplay: {
			delay: 3000,
	},
	effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
	loop: true,
	loopedSlides: 4,
	slideDuplicateActiveClass: 'swiper-slide-active',
	thumbs: {
			swiper: interiorThumb,
	},
});



//슬라이더 값을 실시간으로 적용하는 기능
const rangeInput = document.querySelectorAll('.range-input');

function handleRangeInput(){
	let sVal = this.value;
	const beforeImg = this.parentNode.previousElementSibling.querySelector('.case-before');
	const afterImg = this.parentNode.previousElementSibling.querySelector('.case-after');
	const afterImgObj = this.parentNode.previousElementSibling.querySelector('.case-after img');
	afterImgObj.style.width = beforeImg.offsetWidth;
	afterImg.style.width = 100-sVal + '%';
}

rangeInput.forEach(range=>{
	range.addEventListener('input',handleRangeInput);
	range.addEventListener('change',handleRangeInput);
})